import React, { useState } from 'react';
import { ScreenClassRender } from 'react-grid-system';
import './index.css';

const Input = (props) => {

  const [value, setValue] = useState('');

  function handleTextChange(text) {
    setValue(text);
  }

  return (
    <ScreenClassRender render={screenClass => (
      <div id="float-label">
        <input
          value={value}
          name={props.name}
          onChange={(e) => {
            handleTextChange(e.target.value);
            props.handleInputChange(e)
          }}
          style={{
            height: ["xs", "sm", "md", "lg"].includes(screenClass) ? "40px" : "74px"
          }}
        />

        <label style={{ color: "#8B8989" }}>
          {props.label}
        </label>
      </div>
    )} />
  );
}

export default Input;